import { Component, Input } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SupportTicketService } from '../Model/Support/support-ticket.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { CommonService } from '../Model/Common/common.service';
import { SessionService } from '../Util/Session/session.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { ComboService } from '../Model/Combo/combo.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { EmployeeRegistrationService } from '../Model/EmployeeRegistration/employee-registration.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-client-request-assign',
  standalone: true,
  imports: [LoaderComponent, CommonModule, NgSelectModule, CommonModule, FormsModule],
  templateUrl: './client-request-assign.component.html',
  styleUrl: './client-request-assign.component.scss'
})
export class ClientRequestAssignComponent {

  @Input() InputData: any;
  isDisabled: boolean = false;
  ComplaintTypes: any[] = [];
  UserMaster: any[] = [];
  ComplaintType = null;
  UserId: any = null;
  UserEmail: any = null;
  Remark = '';
  User: any;

  constructor(
    protected common: CommonService,
    private combo: ComboService,
    public activeModal: NgbActiveModal,
    private employeeRegistration: EmployeeRegistrationService,
    private toast: ToastService,
    private modalService: NgbModal,
    private support: SupportTicketService,
    private tooltip: TooltipService,
    private session: SessionService
  ) {
    this.User = this.session.GetUserDetails();
   }

  async ngOnInit() {
    this.ComboLoad('UserMaster');
    await this.ESS_AdditionalFillCombo();
    this.ComplaintType = this.InputData.ESS_ClientPortalComplaintTypeId;
    console.log(this.InputData);
    // this.ESS_ComplaintTypeId = this.InputData.ESS_ComplaintTypeId
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        this.UserMaster = response.ComboLoad;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.employeeRegistration.ESS_AdditionalFillCombo({
        'SelectType': 'ClientPortalComplaintType',
      }).subscribe({
        next: (response) => {
          if (response.Table) {
            this.ComplaintTypes = response.Table
            resolve(true);
          }
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  onUserChange(): void {
    const selectedUserId = this.UserId;
    const selectedUser = this.UserMaster.find((user: { UserMasterId: any; }) => user.UserMasterId === selectedUserId);
    if (selectedUser) {
      this.UserEmail = selectedUser.EmailId;
    } else {
      console.log('User not found.');
    }
  }

  async save(type: string) {

    if (this.ComplaintType === '' || this.ComplaintType === null) {
      this.toast.show({ message: 'Please select Complaint Type.', type: toastTypeEnum.warning });
      return
    }
    if (this.UserId === '' || this.UserId === null) {
      this.toast.show({ message: 'Please select User.', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save ?'
    modalRef.result.then((result: any) => {
      // if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
      if (result) {
        this.SaveUpdate(type);
      }
      // } else {
      //   this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      // }
    }).catch(() => {

    });
  }

  SaveUpdate(type: string) {
    const Detail = {
      SelectType: 'U',
      ESS_ClientPortalHelpDeskRequestId: this.InputData.ESS_ClientPortalHelpDeskRequestID,
      ESS_ClientPortalComplaintTypeId: this.InputData.ESS_ClientPortalComplaintTypeId,
      AdditionalDetails: this.InputData.AdditionalDetails,
      Tr_LoginMasterId: this.InputData.Tr_LoginMasterId,
      SiteId: this.InputData.SiteMasterId,
      ContactNo: this.InputData.ContactNo,
      Description: this.InputData.Description,
      Status: 'Assigned',
      Remarks: this.Remark,
      Email: this.UserEmail,
      Attachment: this.InputData.Attachment,
      AssignedTo: this.UserId,
      AssignedByName: this.User.UserName,
      TicketRaisedDate: this.InputData.RequestedOn,
      CompanyName: this.User.CompanyName
    }
    this.isDisabled = true;
    this.support.ClientPortal_HelpDeskRequestUpdate(Detail).subscribe({
      next: (data) => {
        if (data.ErrorCode == '453') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.ErrorMessage;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Close(true)
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.ErrorMessage;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  Close(type: boolean) {
    this.activeModal.close(type);
  }

}
